<template>
    <section>
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiAccountMultiple }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Member Dependents
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>

        <v-container class="info-main-wrapper d-flex justify-space-around align-center flex-column">
            <div class="dependent-wrapper">
                <!--  DEPENDENTS INFORMATIONS  -->
                <InfoDependent :get-user-dependent="getUserDependent" />
                <!-- END DEPENDENTS INFORMATIONS  -->
            </div>
        </v-container>
    </section>
</template>

<script>
import { mdiAccountMultiple } from '@mdi/js'
import InfoDependent from './MemberDependentComp/InfoDependent.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { InfoDependent },
    data: () => ({
        mdiAccountMultiple
    }),
    computed: {
        ...mapGetters(['getUserDependent', 'getPrincipal', 'getUserInfo'])
    },
    watch: {
        getUserDependent(newVal) {
            if (newVal.length == 0) window.location.href = '/dashboard/info'
        }
    },  
    async mounted () {
        const dependentsPrincipal = await this.getTheUserInfo()
        // this.retrieveUserDependent({ MEMBN: localStorage.getItem("membn") });
        if (dependentsPrincipal != null) {
            this.userDependent({ MEMBN: dependentsPrincipal })
            this.retrievePrincipal({ MEMBN: dependentsPrincipal })
        } else {
            // this.userDependent({ MEMBN: this.$cookies.get("usermembn") });
            await this.userDependent({ MEMBN: this.$cookies.get('usermembn') })
        }
    },
    methods: {
        ...mapActions(['userDependent', 'retrievePrincipal', 'getCsrfToken', 'userInfo']),
        async getTheUserInfo() {
            // await this.getCsrfToken()
            await this.userInfo({ MEMBN: this.$cookies.get('usermembn') })
            const updatedUserInfo = await this.getUserInfo // Retrieve updated state
            return updatedUserInfo.USER_DATA.MEMB_TYPE
        }
    }
}
</script>

<style scoped>
@media (max-width: 390px) {
  /* Navbar */
  .page-icon {
    display: none;
  }
}
@media (max-width: 599px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }

  /* Member Card wrapper */
  .user-card {
    width: 100%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .user-card {
    width: 80%;
  }
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}

.dependent-wrapper {
  width: 95%;
}

@media (max-width: 599px) {
  .dependent-wrapper {
    width: 100%;
  }
}
</style>
